import { CheckoutButton } from "../../Buttons/CheckoutButton";

export function SummarySection({ selectedRate, onSubmit, isLoading }) {
  if (!selectedRate) return null;

  const subtotal = (
    parseFloat(selectedRate.totalCharge) -
    parseFloat(selectedRate.taxCharge) -
    parseFloat(selectedRate.processingCharge || 0)
  ).toFixed(2);
  const tax = parseFloat(selectedRate.taxCharge).toFixed(2);
  const processingFee = parseFloat(selectedRate.processingCharge || 0).toFixed(
    2
  );
  const total = (
    parseFloat(subtotal) +
    parseFloat(tax) +
    parseFloat(processingFee)
  ).toFixed(2);

  return (
    <section
      aria-labelledby="summary-heading"
      className="mt-6 lg:mt-0 lg:col-span-5"
    >
      <div className="rounded-lg bg-white shadow p-6 space-y-6">
        <h2
          id="summary-heading"
          className="text-lg font-semibold text-gray-900 border-b pb-3"
        >
          Order Summary
        </h2>
        <dl className="space-y-3">
          {/* Subtotal */}
          <div className="flex justify-between text-gray-600">
            <dt>Subtotal</dt>
            <dd className="font-medium text-gray-900">
              ${subtotal}{" "}
              <span className="text-gray-500 text-sm">
                {selectedRate.currency}
              </span>
            </dd>
          </div>

          {/* Tax */}
          {parseFloat(selectedRate.taxCharge) > 0 && (
            <div className="flex justify-between text-gray-600">
              <dt>Tax</dt>
              <dd className="font-medium text-gray-900">
                ${tax}{" "}
                <span className="text-gray-500 text-sm">
                  {selectedRate.currency}
                </span>
              </dd>
            </div>
          )}

          {/* Payment Processing Fee */}
          {parseFloat(selectedRate.processingCharge || 0) > 0 && (
            <div className="flex justify-between text-gray-600">
              <dt>Payment Processing Fee</dt>
              <dd className="font-medium text-gray-900">
                ${processingFee}{" "}
                <span className="text-gray-500 text-sm">
                  {selectedRate.currency}
                </span>
              </dd>
            </div>
          )}

          {/* Total */}
          <div className="flex justify-between items-center border-t border-gray-200 pt-4">
            <dt className="text-lg font-bold">Total</dt>
            <dd className="text-lg font-bold text-gray-900">
              ${total}{" "}
              <span className="text-gray-500 text-sm">
                {selectedRate.currency}
              </span>
            </dd>
          </div>
        </dl>
        <CheckoutButton
          onClick={onSubmit}
          isLoading={isLoading}
        />{" "}
      </div>
    </section>
  );
}
